import { createAction } from '@reduxjs/toolkit';

export const showUserStart = createAction('SHOW_USER::START');
